import './App.css';
//import i18n from './i18n';
import Loader from 'react-loader-spinner'
//import ReactGA from 'react-ga';
import { SizerAppAPI }  from './Vendors/SizerAppAPI';
import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, } from 'react-router-dom';
import { PrivateRoute } from './_common/PrivateRoute';
import { ErrorBoundary } from './ErrorBoundary';
import getTheme from './_common/GetTheme';
import translator from './_common/Translator';
import {SizerAppGA} from './Vendors/SizerAppGA'

const SizerScanComponent = lazy(() => import('./Vendors/Sizer/SizerScanComponent'))
const SizerLanding       = lazy(() => import('./Vendors/Sizer/SizerLanding'))
const WacoalScanComponent = lazy(() => import('./Vendors/wacoal/WacoalScanComponent'))
const TriumphScanComponent = lazy(() => import('./Vendors/triumph/TriumphScanComponent'))
const ZylerScanComponent = lazy(() => import('./Vendors/Zyler/ZylerScanComponent'))
const TriumphBoothScanComponent = lazy(() => import('./Vendors/triumph_booth/triumphBoothScanComponent'))

class App extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      themeName: 'pcami sizer-window'
    }

  }

  componentDidMount() {
    // Fix malformed URLs where ? is missing (e.g., /landingcid=Hunter instead of /landing?cid=Hunter)
    const pathname = window.location.pathname;
    const cidMatch = pathname.match(/^\/landingcid=(.+)$/);
    const tcidMatch = pathname.match(/^\/landingtcid=(.+)$/);

    if (cidMatch) {
      window.location.href = '/landing?cid=' + cidMatch[1];
      return;
    }
    if (tcidMatch) {
      window.location.href = '/landing?tcid=' + tcidMatch[1];
      return;
    }

    //const urlQuery = new URLSearchParams(document.location.search)
    this.setState({ themeName: getTheme() + " sizer-window " + translator.getLanguageCode()});

//      ReactGA.initialize('UA-209501770-1');
//      ReactGA.pageview(window.location.pathname + window.location.search);
    SizerAppGA.initializeGA();
    SizerAppGA.reportScreenView('loading-sizer');
    // SizerAppGA.reportPageView(window.location.pathname + window.location.search);
  }

  render() {
    const widgetConfig = SizerAppAPI.GetWidgetConfig();
    var loader = (<Loader
          type="ThreeDots"
          color="#988FFF"
          height={60}
          width={60}
        />);
      if (widgetConfig.mode==='widget') {
        loader = (<Loader
                  type="ThreeDots"
                  color="#ffffff"
                  height={20}
                  width={20}
                />);
      }

    let theme = widgetConfig.theme;
//    var component = (<PrivateRoute exact path="/" component={SizerScanComponent} />);
    var component = (<PrivateRoute component={SizerScanComponent} />);
    if (window.location.href.includes('/landing')) {
      component = (<PrivateRoute component={SizerLanding} />);
    }
    else if (theme === 'wacoal') {
      component = (<PrivateRoute component={WacoalScanComponent} />);
    }
    else if (theme === 'zyler') {
      component = (<PrivateRoute component={ZylerScanComponent} />);
    }
    else if (theme === 'triumph') {
      const urlQuery = new URLSearchParams(document.location.search)
      var isBooth = urlQuery.get('booth')
      if (isBooth==='true')
        component = (<PrivateRoute component={TriumphBoothScanComponent} />);
      else
        component = (<PrivateRoute component={TriumphScanComponent} />);
    }

    return (
      <ErrorBoundary>
        <div id='sizer_window' className={this.state.themeName}>
          <div className="col-sm-offset-2">
            <Router>
              <Suspense
              fallback={<>{loader}</>
              }>

                {/*              
                <PrivateRoute component={SizerScanComponent} />
              */}
              {component}
                
            </Suspense>
            </Router>
          </div>
        </div>
      </ErrorBoundary>
    );
  }
}

export default App;

/*
function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          <div className='card'>
            aaa
          </div>
          Edit <code>src/App.js</code> and save to reload.
        </p>
        <a
          className="App-link"
          href="https://reactjs.org"
          target="_blank"
          rel="noopener noreferrer"
        >
          Learn React
        </a>
      </header>
    </div>
  );
}

export default App;
*/